/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents a step of a new person's onboarding. Students: form, payment
 * method, payment plan, tutor assigned, first meeting. A parent with no
 * students yet: form and payment method. Tutors: form, account, bank.
 */
export enum OnboardingStep {
  FORM = "form",
  PAYMENT_METHOD = "payment_method",
  PAYMENT_PLAN = "payment_plan",
  TUTOR_ASSIGNED = "tutor_assigned",
  FIRST_MEETING = "first_meeting",
  ACCOUNT = "account",
  BANK = "bank",
}
